// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-xs{padding:.5rem;font-size:75%;line-height:1;border-radius:1rem}.l-base #footer #footerbar{min-height:calc(50px + var(--safe-area-inset-bottom));box-shadow:0 -.125rem .25rem rgba(56,56,56,.2)}.l-base #footer #footerbar .nav-link{font-size:1.25rem;height:calc(50px + var(--safe-area-inset-bottom))}", ""]);
// Exports
module.exports = exports;
